export const FAR_TOOLTIP_DEFAULT_DISTANCE_PX = 40;
